var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYujalogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 3602 3601",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1140_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.758,
    y: 292.469,
    width: 2164.48,
    height: 1808.75,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1645.75,
    y: 1769.62,
    width: 1592.42,
    height: 1260.1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.79 2039.02V2833.35C1458.79 2986.52 1583.4 3111.14 1736.58 3111.14H2524.05L2824.73 3411.81C2846.06 3433.09 2874.34 3444.43 2903.18 3444.43C2917.51 3444.43 2932.01 3441.65 2945.84 3435.93C2987.51 3418.65 3014.4 3378.37 3014.4 3333.26V3111.14H3181.07C3334.25 3111.14 3458.86 2986.52 3458.86 2833.35V1833.31C3458.86 1680.14 3334.25 1555.52 3181.07 1555.52H2547.05M1569.9 2039.02V2833.35C1569.9 2925.24 1644.68 3000.02 1736.58 3000.02H2547.05C2561.83 3000.02 2575.88 3005.86 2586.33 3016.3L2865.09 3260.45L2903.28 3055.58C2903.28 3024.91 2928.12 3000.02 2958.84 3000.02H3181.07C3272.97 3000.02 3347.75 2925.24 3347.75 2833.35V1833.31C3347.75 1741.42 3272.97 1666.64 3181.07 1666.64H2547.05",
    stroke: "url(#paint0_linear_1140_2)",
    strokeWidth: 238.104
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.752 2532.31L743.787 2532.32C767.065 2541.95 791.521 2546.65 815.731 2546.65C864.559 2546.65 912.3 2527.44 948.169 2491.67L948.19 2491.64L948.211 2491.62L1312.98 2126.86H2285.09C2504.31 2126.86 2682.59 1948.58 2682.59 1729.36V469.788C2682.59 250.564 2504.31 72.2871 2285.09 72.2871H465.713C246.488 72.2871 68.2109 250.564 68.2109 469.788V1729.36C68.2109 1948.58 246.488 2126.86 465.713 2126.86H628.021V2359C628.021 2435.07 673.472 2503.17 743.752 2532.31ZM303.405 469.788C303.405 380.349 376.271 307.481 465.713 307.481H2285.09C2374.53 307.481 2447.4 380.349 2447.4 469.788V1729.36C2447.4 1818.8 2374.53 1891.66 2285.09 1891.66H1264.28C1233.61 1891.66 1204.33 1903.58 1182.4 1924.87L895.197 2176.41L863.11 2004.31C860.521 1941.71 808.984 1891.66 745.616 1891.66H465.713C376.271 1891.66 303.405 1818.8 303.405 1729.36V469.788Z",
    fill: "#331863",
    stroke: "#331863",
    strokeWidth: 95.2415
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.81 1553.3C1433.04 1553.3 1477.81 1508.53 1477.81 1453.3C1477.81 1398.07 1433.04 1353.29 1377.81 1353.29C1322.58 1353.29 1277.8 1398.07 1277.8 1453.3C1277.8 1508.53 1322.58 1553.3 1377.81 1553.3Z",
    fill: "#331863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.45 1171.2V1104.37C1526.05 1104.37 1645.75 999.622 1645.75 870.481C1645.75 741.34 1526.05 636.592 1378.45 636.592C1230.84 636.592 1111.14 741.34 1111.14 870.481V903.894",
    stroke: "#331863",
    strokeWidth: 214.293,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2096.77 2269.8H1961.05C1923.57 2269.8 1893.19 2300.19 1893.19 2337.66V2473.38C1893.19 2510.86 1923.57 2541.24 1961.05 2541.24H2096.77C2134.24 2541.24 2164.63 2510.86 2164.63 2473.38V2337.66C2164.63 2300.19 2134.24 2269.8 2096.77 2269.8Z",
    fill: "#331863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2529.81 2269.8H2394.09C2356.61 2269.8 2326.23 2300.19 2326.23 2337.66V2473.38C2326.23 2510.86 2356.61 2541.24 2394.09 2541.24H2529.81C2567.28 2541.24 2597.67 2510.86 2597.67 2473.38V2337.66C2597.67 2300.19 2567.28 2269.8 2529.81 2269.8Z",
    fill: "#331863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2962.86 2269.8H2827.14C2789.66 2269.8 2759.28 2300.19 2759.28 2337.66V2473.38C2759.28 2510.86 2789.66 2541.24 2827.14 2541.24H2962.86C3000.34 2541.24 3030.72 2510.86 3030.72 2473.38V2337.66C3030.72 2300.19 3000.34 2269.8 2962.86 2269.8Z",
    fill: "#331863"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1140_2",
    x1: 4058.87,
    y1: 1667.57,
    x2: 1865.01,
    y2: 3133.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#007474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#018384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#009191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CCCC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYujalogo);
export default __webpack_public_path__ + "static/media/yujalogo.a44212b933188f4502c5e13c67f6cd47.svg";
export { ForwardRef as ReactComponent };